import { ComponentTypes } from "@/Apps/Pages/Editor/types";
import { ComponentRenderHooks, HookObject } from "@/plugins/types";

import EditorPicture, { Properties, SimplePictureProperties, SimplePictureUploadOverlay } from "./Picture";
import settings from "./settings";

export const onComponentRender = (hook, payload, actions) => {
  if (
    hook.id === ComponentRenderHooks.WEBCOMPONENT &&
    payload.type === "Picture"
  ) {
    return [EditorPicture];
  }
  
  if (
    hook.id === ComponentRenderHooks.PROPERTIES &&
    hook.type === ComponentTypes.PICTURE
  ) {
    return Properties(payload);
  }

  if (
    hook.id === ComponentRenderHooks.SIMPLE_PROPERTIES &&
    hook.type === ComponentTypes.PICTURE
  ) {
    return SimplePictureProperties(payload);
  }

  // Use this to wrap the picture in a dropzone
  if (
    hook.id === ComponentRenderHooks.WEBCOMPONENT_OVERLAY &&
    payload.type === ComponentTypes.PICTURE
  ) {
    return [SimplePictureUploadOverlay];
  }
};

export const onListItems = (hook: HookObject) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT) {
    return [settings];
  }

  // if (
  //   hook.id === ListItemsHooks.PROPERTIES &&
  //   hook.type === ComponentTypes.PICTURE // || hook.type === ComponentTypes.IMAGE)
  // ) {
  //   return properties || {};
  // }
};
